export default __webpack_public_path__ + "static/match-46b317366f0fbc4c4b915601b5f597b2.svg";